/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Payments_Tab_RenewInputs */

const en_settings_payments_tab_renew = /** @type {(inputs: Settings_Payments_Tab_RenewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renewal`)
};

const zh_settings_payments_tab_renew = /** @type {(inputs: Settings_Payments_Tab_RenewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`续订`)
};

/**
* | output |
* | --- |
* | "Renewal" |
*
* @param {Settings_Payments_Tab_RenewInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_payments_tab_renew = /** @type {((inputs?: Settings_Payments_Tab_RenewInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Payments_Tab_RenewInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_payments_tab_renew(inputs)
	return zh_settings_payments_tab_renew(inputs)
});
export { settings_payments_tab_renew as "settings.payments.tab_renew" }